import { action } from "satcheljs";
import type { DragData } from "owa-dnd/lib/utils/dragDataUtil";

export interface LaunchFullComposeFromDropDataActionMessage {
    dragData: DragData;
}
export const launchFullComposeFromDropData: (dragData: DragData) => LaunchFullComposeFromDropDataActionMessage = action("launchFullComposeFromDropData", (dragData: DragData): LaunchFullComposeFromDropDataActionMessage => ({
    dragData,
}));
